import script from "./history.vue?vue&type=script&setup=true&lang=ts"
export * from "./history.vue?vue&type=script&setup=true&lang=ts"

import "./history.vue?vue&type=style&index=0&id=72a509b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72a509b6"]])

export default __exports__